<template>
   <Listbox
      as="div"
      v-model="selected"
      class="w-full md:w-1/2 md:pr-6"
   >
      <div class="relative">
         <ListboxButton
            :class="{
               'pulse border-dgreen': !keysSelected,
               'border-red-500 ': $page.props.errors.keysSelected && !keysSelected,
            }"
            class="bg-white relative w-full border border-gray-300 rounded-md shadow pl-4 pr-10 py-4 text-left cursor-pointer focus:outline-hidden hover:shadow-md transition-shadow"
         >
            <span
               v-if="keysSelected"
               class="flex items-center"
            >
               <span class="inline-block">{{ keyQty }} sleutels</span>
               <span
                  v-if="keyQty - default_qty > 0 && product.key_price.price > 0"
                  class="rounded px-2 py-1 text-xs bg-gray-200 ml-2"
                  >+ {{ price((keyQty - default_qty) * product.key_price.price) }}</span
               ><span
                  v-else
                  class="pl-2"
                  >(standaard)</span
               >
            </span>
            <span
               v-else
               class="block truncate"
               >Kies het gewenste aantal</span
            >
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
               <fa
                  :icon="['fal', 'angle-down']"
                  class="h-4 w-4 text-gray-400"
               />
            </span>
         </ListboxButton>

         <!-- <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0"> -->
         <transition name="drop">
            <ListboxOptions
               class="absolute z-20 w-full bg-white shadow-lg max-h-[380px] md:max-h-fit -mt-16 rounded-md py-1 text-base ring-1 ring-black/10 overflow-auto focus:outline-hidden"
            >
               <ListboxOption
                  as="template"
                  v-for="n in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]"
                  :key="n"
                  :value="n"
                  v-slot="{ active, selected }"
               >
                  <div>
                     <li
                        :class="[
                           selected || active ? 'bg-gray-100' : 'text-gray-900',
                           'cursor-default select-none relative py-2 pl-4 pr-9',
                        ]"
                        @click="
                           resetColors(n);
                           $emit('update:keyQty', n);
                           $emit('update:keysSelected', true);
                           showCustomKeyQty = false;
                        "
                        v-if="show(n)"
                     >
                        <div
                           :class="[selected ? 'font-semibold' : 'font-normal', 'block']"
                           class="flex items-center"
                        >
                           <span class="inline-block">{{ n }} sleutels</span>

                           <span
                              class="text-gray-600 ml-1 inline-block"
                              v-if="default_qty != n"
                           >
                              <span
                                 v-if="n - default_qty > 0"
                                 class="rounded px-2 py-1 text-xs bg-gray-200 ml-2"
                                 >+ {{ price((n - default_qty) * product.key_price.price) }}</span
                              >
                           </span>
                           <span
                              v-else
                              class="pl-2"
                              >(standaard)</span
                           >
                        </div>

                        <span
                           v-if="selected"
                           class="absolute inset-y-0 right-0 flex items-center pr-4"
                        >
                           <fa
                              :icon="['fal', 'check']"
                              class="h-5 w-5 text-gray-400"
                           />
                        </span>
                     </li>
                  </div>
               </ListboxOption>
               <ListboxOption @click="customQty()">
                  <li class="border-t cursor-pointer select-none relative py-2 pl-4 text-gray-900 hover:bg-gray-100 flex items-center">
                     <span class="inline-block"><strong>Meer dan 18 sleutels?</strong> Voer eigen aantal in</span>
                  </li>
               </ListboxOption>
            </ListboxOptions>
         </transition>
      </div>
      <div class="w-full">
         <span
            class="text-blue-600 block mt-2 cursor-pointer hover:text-blue-600"
            @click="showCustomKeyQty = true"
            v-if="!showCustomKeyQty"
            >+ Meer dan 18 sleutels nodig?</span
         >

         <span
            class="text-blue-600 block mt-2 cursor-pointer hover:text-blue-600"
            @click="showCustomKeyQty = false"
            v-if="showCustomKeyQty"
            >- Verberg</span
         >

         <quantity-input
            v-if="showCustomKeyQty"
            v-model:qty="selected"
            min="0"
            max="999"
            :default="default_qty"
            class="mt-4"
         />
      </div>
   </Listbox>
   <div
      class="w-full md:w-1/2 relative md:h-12 flex flex-wrap"
      v-if="caps && caps.length && keysSelected"
   >
      <div class="md:absolute md:-top-10 mt-10 md:mt-0">
         <InfoModal
            v-if="[1, 11, 4, 7, 31, 32, 80, 81, 211, 205, 154, 155, 156, 157, 158, 159, 160, 251].includes(product.id)"
            title="Kleurencaps"
            link="/api/attributes/kleuren-caps"
         >
            Kleurencaps
         </InfoModal>
         <span v-else>Type sleutel</span>
      </div>
      <div
         class="w-full md:w-1/2 mt-4 md:pr-4 md:mt-0"
         v-if="![1, 11, 4, 7, 31, 32, 80, 81, 211, 205, 154, 155, 156, 157, 158, 159, 160, 251].includes(product.id)"
      >
         <div
            class="rounded px-6 py-4 border cursor-pointer"
            :class="{ 'border-green-600': !customColors }"
            @click="$emit('update:customColors', false)"
         >
            <div class="flex items-center">
               <VuePicture
                  :image="{ src: asset('img/metalen-sleutel.png'), origin_src: asset('img/metalen-sleutel.png') }"
                  class="h-10 inline-block -m-2 mr-2"
               />
               <span>Metaal</span>
               <span
                  class="green-check"
                  v-if="!customColors"
               >
                  <fa :icon="['fal', 'check']" />
               </span>
            </div>
         </div>
      </div>

      <div class="w-full md:w-1/2 md:pr-4 md:mt-0 mt-4">
         <div
            :class="{ 'border border-green-600': customColors && !selectedColor }"
            class="rounded-md px-6 py-4 border cursor-pointer"
            @click="
               $emit('update:customColors', true);
               resetColors()
            "
         >
            <span v-if="![1, 11, 9, 4, 7, 31, 32, 80, 81, 211, 205, 154, 155, 156, 157, 158, 159, 160].includes(product.id)">
               <div class="flex items-center">
                  <VuePicture
                     :image="{
                        src: asset('img/kunststof-sleutel.png'),
                        origin_src: asset('img/kunststof-sleutel.png'),
                     }"
                     class="h-10 inline-block -m-2 mr-2"
                  />
                  <span>Kunststof</span>
                  <span
                     class="green-check"
                     v-if="customColors && !selectedColor"
                  >
                     <fa :icon="['fal', 'check']" />
                  </span>
               </div>
            </span>

            <span
               v-else
               class="flex items-center justify-between"
            >
               <span v-if="compact"> Kiezen </span>
               <span v-else> Zelf kiezen </span>
               <span
                  class="green-check inline-flex w-6 h-6 items-center justify-center rounded-full"
                  v-if="customColors && !selectedColor"
               >
                  <fa
                     :icon="['fal', 'check']"
                     class="text-xs"
                  />
               </span>
            </span>
         </div>
      </div>

      <Listbox
         as="div"
         v-model="selectedColor"
         class="w-full md:w-1/2 mt-4 md:mt-0"
         v-if="[1, 11, 4, 7, 31, 32, 80, 81, 211, 205, 154, 155, 156, 157, 158, 159, 160].includes(product.id)"
      >
         <div class="relative">
            <ListboxButton
               :class="{ 'border border-green-600': selectedColor }"
               class="bg-white relative w-full border border-gray-300 rounded-md shadow pl-4 pr-10 py-4 text-left cursor-pointer focus:outline-hidden hover:shadow-md transition-shadow"
            >
               <span
                  class="flex items-center"
                  v-if="selectedColor"
               >
                  <fa
                     :icon="['fas', 'circle']"
                     class="text-gray-400 -rotate-45 text-lg mr-4"
                     :class="selectedColor.name.toLowerCase()"
                     :value="selectedColor.name"
                  />
                  <span class="inline-block">{{ selectedColor.name }}</span>
               </span>

               <span v-else>Kies één kleur</span>

               <span class="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                  <fa
                     :icon="['fal', 'angle-down']"
                     class="h-4 w-4 text-gray-400"
                  />
               </span>
            </ListboxButton>

            <!-- <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0"> -->
            <transition name="drop">
               <ListboxOptions
                  class="absolute z-20 w-full bg-white shadow-lg ax-h-60 md:max-h-fit -mt-16 rounded-md py-1 text-base ring-1 ring-black/10 overflow-auto focus:outline-hidden"
               >
                  <ListboxOption
                     v-for="(color, index) in caps"
                     :key="index"
                     as="template"
                  >
                     <li
                        class="cursor-default select-none relative py-2 pl-4 text-gray-900 hover:bg-gray-100 flex items-center"
                        @click="setSingleColor(color)"
                     >
                        <fa
                           :icon="['fas', 'circle']"
                           class="text-gray-400 -rotate-45 text-lg mr-4"
                           :class="color.name.toLowerCase()"
                           :key="index"
                           :value="color.name"
                        />
                        <span class="inline-block">{{ color.name }}</span>

                        <!-- <span class="absolute inset-y-0 right-0 flex items-center pr-4">
                                        <fa :icon="['fal', 'check']" class="h-5 w-5 text-gray-400" />
                                    </span> -->
                     </li>
                  </ListboxOption>
               </ListboxOptions>
            </transition>
         </div>
      </Listbox>
   </div>
   <transition name="drop">
      <div
         class="flex flex-wrap w-full pt-6"
         v-if="caps && caps.length && customColors && keysSelected && !selectedColor"
      >
         <div class="flex flex-wrap w-full mb-6">
            <span
               v-for="(color, index) in caps"
               :key="index"
            >
               <fa
                  v-if="color.qty > 0"
                  v-for="n in color.qty"
                  :icon="['fas', 'key']"
                  class="text-gray-400 -rotate-45 text-2xl"
                  :class="color.name.toLowerCase()"
               />
            </span>

            <span
               v-for="key in keysLeft"
               :key="key"
            >
               <fa
                  :key="key"
                  :icon="['fal', 'key']"
                  class="text-gray-400 -rotate-45 text-2xl"
               />
            </span>
         </div>

         <div
            v-for="(color, index) in caps"
            :key="index"
            class="items-center flex flex-wrap w-1/2 md:w-1/3 py-2"
         >
            <fa
               :icon="['fas', 'key']"
               class="text-gray-400 -rotate-45 text-2xl mr-4"
               :class="color.name.toLowerCase()"
            />

            <button
               @click="decrement(color)"
               type="button"
               class="inline-flex items-center p-1.5 border rounded-full shadow border-gray-300 text-gray-500 bg-white hover:bg-gray-100 focus:outline-hidden"
               :class="{ 'opacity-25': color.qty == 0 }"
            >
               <fa
                  :icon="['fal', 'minus']"
                  class="block h-4 w-4"
               />
            </button>

            <!-- <input type="number" @input="updateManual" v-model="quantity" :min="min" :max="max" class="text-center border-none w-16 p-3"> -->
            <span class="inline-block mx-4">{{ color.qty }}</span>

            <button
               @click="increment(color)"
               type="button"
               class="inline-flex items-center p-1.5 border rounded-full shadow border-gray-300 text-gray-500 bg-white hover:bg-gray-100 focus:outline-hidden"
               :class="{ 'opacity-25': keysLeft == 0 }"
            >
               <fa
                  :icon="['fal', 'plus']"
                  class="block h-4 w-4"
               />
            </button>
         </div>
      </div>
   </transition>
</template>

<script>
import QuantityInput from '@/Blocks/QuantityInput.vue'
import { computed, ref, watch, onMounted } from 'vue'
import { usePage } from '@inertiajs/vue3'

export default {
   props: {
      default_qty: Number,
      keyQty: Number | Boolean,
      keysSelected: Boolean,
      caps: Array,
      customColors: Boolean,
      product: Object,
      compact: Boolean,
   },

   components: {
      QuantityInput,
   },

   computed: {
      selectedColor() {
         let self = this
         let color = false

         this.caps.forEach(function (value, key) {
            if (value.qty == self.keyQty) {
               color = value
            }
         })

         return color
      },
   },

   setup(props, context) {
      const inBrowser = typeof window !== 'undefined'
      const ab_variant = usePage().props.ab_variant

      onMounted(() => {
         if (inBrowser) {
            dataLayer.push({
               event: 'configuration_steps',
               ab_variant: ab_variant,
               step_name: '2. Opties',
            })
         }
      })

      const selected = ref(props.keyQty)
      var showCustomKeyQty = ref(props.keyQty > 18 ? true : false)

      const keysLeft = computed(() => {
         let left = 0

         if (props.caps && props.caps.length) {
            props.caps.forEach(function (value, key) {
               // if (index != key) {
               left = left + parseInt(value.qty)
               // }
            })
         }

         return props.keyQty - left
      })

      function setSingleColor(color) {
         // let self = this;

         props.caps.forEach(function (value, key) {
            if (value.name == color.name) {
               value.qty = props.keyQty
            } else {
               value.qty = 0
            }
         })
      }

      function resetColors() {
         props.caps.forEach(function (value, key) {
            value.qty = 0
         })
      }

      function show(qty) {
         if (props.product.reorder_type == 2 && qty == 0) {
            return false
         }

         return qty >= props.default_qty
      }

      function increment(color) {
         if (this.keysLeft > 0) {
            if (color.qty < 20) color.qty++
         }
      }

      function decrement(color) {
         if (color.qty > 0) {
            color.qty--
         }
      }

      function updateQty(qty) {
         context.emit('update:keyQty', qty)
         context.emit('update:keysSelected', true)
      }

      function customQty() {
         selected.value = 20
         showCustomKeyQty.value = true
         this.updateQty(20)
      }

      watch(selected, (newVal) => {
         console.log(newVal)
         if (inBrowser) {
            dataLayer.push({
               event: 'configuration_steps',
               ab_variant: ab_variant,
               step_name: '3. Sleutels',
            })

            if (props.product.reorder_type != 1) {
               dataLayer.push({
                  event: 'configuration_completed',
                  ab_variant: ab_variant,
               })
            }
         }
         updateQty(newVal)
      })

      return {
         selected,
         show,
         increment,
         decrement,
         keysLeft,
         resetColors,
         showCustomKeyQty,
         updateQty,
         setSingleColor,
         customQty,
      }
   },
}
</script>
<style>
.marineblauw {
   color: navy;
}

.donkerblauw {
   color: rgb(0, 0, 216);
}

.lichtblauw {
   color: #0090e3;
}

.rood {
   color: #f20000;
}

.roze {
   color: #e607b9;
}

.lichtgroen {
   color: #00d40e;
}

.geel {
   color: #fe0;
}

.donkergroen {
   color: #0b6e00;
}

.oranje {
   color: #ff6f00;
}

.paars {
   color: #a0f;
}

.grijs {
   color: #ccc;
}

.zwart {
   color: #000 !important;
}

/* Product info */
.specs td {
   padding: 8px 12px;
}
</style>
